export interface EDTFValidation {
    type: EDTFValidationType;
    level: number;
    values: (EDTFValidation | number | 'Infinity' | null)[];
    offset?: number;
    approximate?: boolean;
    uncertain?: boolean;
    unspecified?: number;
}

export const enum EDTFValidationType {
    DATE = 'Date',
    YEAR = 'Year',
    DECADE = 'Decade',
    CENTURY = 'Century',
    SEASON = 'Season',
    INTERVAL = 'Interval',
    List = 'List',
    Set = 'Set'
}

export const COMPLETELY_UNSPECIFIED_EDTF_FORMAT = 'XXXX-XX-XX';
